// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"675":"c3e48be2","1988":"2680b339"}[chunkId] + ".chunk.css";
};